<template>
  <b-navbar toggleable="lg" type="light" sticky class="border-bottom" variant="white">
    <div class="container py-0 px-md-2">
    <b-navbar-brand v-if="isLoggedIn" to="/" class="pl-md-1"><i class="fas fa-home"></i></b-navbar-brand>
    <b-navbar-toggle class="ml-auto" target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item :href="shopUrl + 'collections/alle-produkte'" target="_blank" >
          Zum Shop
        </b-nav-item>
        <b-nav-item v-if="!isLoggedIn">
          <b-link to="/">Anmelden</b-link>
        </b-nav-item>
        <b-nav-item to="/products" v-if="isLoggedIn">
          Produkte
        </b-nav-item>
        <feature name="documents">
          <b-nav-item to="/documents" v-if="isLoggedIn">
            Dokumente
          </b-nav-item>
        </feature>
        <feature name="uber">
          <b-nav-item to="/jobs" v-if="isLoggedIn">
            Jobs
          </b-nav-item>
        </feature>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto" v-if="isLoggedIn">
        <b-nav-item-dropdown right>
          <template #button-content>
            <em>{{ userEmail }}</em>
          </template>
          <b-dropdown-item to="/profile">Profile</b-dropdown-item>
          <b-dropdown-item @click="logout">Abmelden</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
import { FeatureToggleComponent as feature } from 'vue-feature-toggle';
import {mapGetters, mapState} from "vuex";
import platformSettings from "~config/settings";
import firebase from "firebase";

platformSettings.features.forEach(featureName => feature.visibility(featureName, true))

export default {
  components: { feature },
  computed: {
    ...mapState({
        userEmail: state => state.user.user.email
    }),
    ...mapGetters('user', ['isLoggedIn']),
    shopUrl () {
      return platformSettings.shopUrl
    },
  },
  methods: {
    async logout() {
      firebase.auth().signOut();
      await this.$store.dispatch('user/doLogout').then(() => {
          this.$router.go(0)
      })
    },
  }
}
</script>
